let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iVY6B")).then(() => parcelRequire('j4kfU'));